import React from 'react';
import { Icon } from '@aws-amplify/ui-react';
import {
  MdRocketLaunch,
  MdViewModule,
  MdAspectRatio,
  MdInventory2,
  MdCollections,
  MdHome,
} from 'react-icons/md';
import GeistiMark from './shared/GeistiMark';

export const baseConfig = {
  titleSuffix: '',
  header: true,
  headerText: 'geisti',
  footer: false,
  footerText: '',
  logo: <GeistiMark size={36} />,
};

export interface NavItem {
  eventKey: string;
  icon: React.ReactNode;
  title: string;
  to: string;
  badge?: React.ReactNode;
}

export interface NavGroup {
  eyebrow?: string;
  items: NavItem[];
}

export const appNavs: NavGroup[] = [
  {
    eyebrow: 'CATALOG',
    items: [
      {
        eventKey: 'listings',
        icon: <Icon as={MdViewModule} />,
        title: 'Listings',
        to: '/listings',
      },
      {
        eventKey: 'collections',
        icon: <Icon as={MdCollections} />,
        title: 'Collections',
        to: '/collections',
      },
      {
        eventKey: 'formats',
        icon: <Icon as={MdAspectRatio} />,
        title: 'Formats',
        to: '/formats',
      },
      {
        eventKey: 'homepage',
        icon: <Icon as={MdHome} />,
        title: 'Homepage',
        to: '/homepage',
      },
    ],
  },
  {
    eyebrow: 'OPS',
    items: [
      {
        eventKey: 'orders',
        icon: <Icon as={MdInventory2} />,
        title: 'Orders',
        to: '/orders',
      },
    ],
  },
  {
    eyebrow: 'STUDIO',
    items: [
      { eventKey: 'designs', icon: <Icon as={MdRocketLaunch} />, title: 'Designs', to: '/designs' },
    ],
  },
];
